import React from 'react';

// eslint-disable-next-line react/prop-types
const BackArrow = () => (
  <svg
    width="32px"
    height="23px"
    viewBox="0 0 32 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>BD362A69-58D2-4B2B-AA8C-81B74930E27E</title>
    <desc>Created with sketchtool.</desc>
    <g
      id="Final-design--(Web)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Signup-Step-2-"
        transform="translate(-826.000000, -166.000000)"
        fill="#1E201D"
        fillRule="nonzero"
      >
        <g
          id="right-arrow-(2)"
          transform="translate(842.000000, 177.500000) rotate(-180.000000) translate(-842.000000, -177.500000) translate(826.000000, 166.000000)"
        >
          <path
            d="M21.205,1.007 C20.776,0.563 20.062,0.563 19.618,1.007 C19.189,1.436 19.189,2.15 19.618,2.578 L27.665,10.625 L1.111,10.625 C0.492,10.626 0,11.118 0,11.737 C0,12.356 0.492,12.864 1.111,12.864 L27.665,12.864 L19.618,20.896 C19.189,21.34 19.189,22.055 19.618,22.483 C20.062,22.927 20.777,22.927 21.205,22.483 L31.157,12.531 C31.601,12.102 31.601,11.388 31.157,10.96 L21.205,1.007 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default BackArrow;
